@if (shouldDisplay()) {
    <ui-banner variant="warning">
        <div>
            <strong>{{ 'payroll.contactSetup.title' | translate }}</strong>
            <p [innerHTML]="'payroll.contactSetup.description' | translate"></p>
        </div>
    </ui-banner>
}
